export default "__VITE_ASSET__BAbbFy6Z__"